import type { PaginationModel } from '@montugroup/design-system';

type HandlePaginationParams = {
  prevPage: PaginationModel;
  page: number;
};

type ResponseCursors = {
  next: string | null;
  prev: string | null;
};

type HandlePaginationBuilderParams = {
  responseCursors: ResponseCursors;
  setCursors: (value: React.SetStateAction<ResponseCursors>) => void;
};

export const handlePaginationChangeBuilder = ({ responseCursors, setCursors }: HandlePaginationBuilderParams) => {
  const handlePaginationChange = ({ prevPage, page: newPage }: HandlePaginationParams) => {
    const cursorKey = newPage > prevPage.page ? 'next' : 'prev';
    if (responseCursors?.[cursorKey]) {
      if (cursorKey === 'next') {
        setCursors({ prev: null, next: responseCursors[cursorKey] });
      } else {
        setCursors({ prev: responseCursors[cursorKey], next: null });
      }
    }
  };

  return handlePaginationChange;
};
